import { Box } from '@mui/material'
import React from 'react'
import IconArrowBottom from '../../assets/images/icons/icon-arrow-bottom'
import { insightsAssistant } from '../../assets/images/icons'
import { useGlobalStore } from '../../store'

const Chatter = ({ isQuestion = false, userName = '' }) => {
  const { theme } = useGlobalStore()
  const isLightTheme = theme === 'light'

  const getInitials = () => {
    return userName
      ?.split(' ')
      .map((part) => part[0]?.toUpperCase())
      .join('')
  }

  return (
    <Box
      sx={{
        width: '48px',
        height: '48px',
        minWidth: '48px',
        background: isLightTheme ? (isQuestion ? '#5B92D3' : '#fff') : '#323639',
        borderRadius: isQuestion ? '30px 0 30px 30px' : '30px 30px 0px 30px',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '7px 5px',
        color: '#fff',
        fontSize: '19px',
        fontWeight: 400,
        marginTop: 'auto',
      }}
    >
      {isQuestion ? (
        getInitials()
      ) : (
        <img src={insightsAssistant} height='34' width='38' alt='Insights Assistant' />
      )}
    </Box>
  )
}

export default Chatter
